const q = (t) => encodeURIComponent(`${t.artist || ""} ${t.title || ""}`.trim());

export const listenLinks = (t) => [
  { key: "spotify", label: "Spotify", href: `https://open.spotify.com/search/${q(t)}` },
  { key: "youtube", label: "YouTube", href: `https://www.youtube.com/results?search_query=${q(t)}` },
];

export const ListenLinks = ({ track, testId = "listen" }) => (
  <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-2">
    <span className="text-[11px] uppercase tracking-[0.2em] text-zinc-400 font-bold">Écouter sur</span>
    {listenLinks(track).map((l) => (
      <a key={l.key} href={l.href} target="_blank" rel="noreferrer" data-testid={`${testId}-${l.key}`}
        className="text-[11px] uppercase tracking-[0.2em] font-bold text-white underline decoration-primary decoration-2 underline-offset-4 hover:text-primary transition-colors">
        {l.label}
      </a>
    ))}
  </div>
);
